import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKitesurfNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.096 10.52L13.01 4.87c.076-1.361-.304-2.663-1.25-3.61C10.64.141 9.026-.185 7.403.095c-1.626.28-3.322 1.171-4.73 2.58C1.267 4.081.375 5.777.095 7.402c-.28 1.624.046 3.237 1.165 4.356.969.968 2.309 1.344 3.703 1.245l5.563 1.085-.968.969.884.884 5.5-5.5-.884-.884zM3.558 3.558A8.629 8.629 0 015.592 2.04l.74 2.033a7.864 7.864 0 00-1.244 1.015c-.39.39-.729.808-1.014 1.243l-2.034-.74a8.63 8.63 0 011.518-2.033zm3.886-.083l-.702-1.93a6.17 6.17 0 01.874-.218c1.344-.232 2.504.062 3.26.817.374.374.635.847.774 1.393-.828-.512-1.851-.638-2.867-.462a6.056 6.056 0 00-1.34.4zM5.972 5.972c.257-.257.525-.485.8-.685l.85 2.334-2.335-.849c.2-.275.428-.544.685-.8zm-4.426.77l1.93.702c-.19.444-.325.894-.401 1.339-.175 1.015-.05 2.039.463 2.867a2.992 2.992 0 01-1.394-.775c-.755-.755-1.049-1.915-.817-3.26a6.17 6.17 0 01.22-.873zm6.777 2.464l3.543 3.544-.274.274-5.953-1.161a.623.623 0 00-.137-.084 2.046 2.046 0 01-.611-.42c-.535-.535-.756-1.368-.584-2.364.063-.365.178-.744.345-1.123zm4.705 2.382l-.278.278-3.544-3.544-1.334-3.67c.38-.167.758-.283 1.124-.346.995-.171 1.829.05 2.363.585.177.176.316.381.42.611.028.064.067.12.113.17z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKitesurfNormalXsmall;
